export default __webpack_public_path__ + "static/media/Template12.00966a0c.png";